export default __webpack_public_path__ + "static/O0031-1d417393925cf28e36f7a4b74268d3ca.png";